import React, { useEffect } from 'react';
import { Btn } from 'components/btn/Btn';
import { LinkBtn } from 'components/link-btn';
import { Modal } from 'components/modal/Modal';
import cellCardImg from 'media/images/cellCard.png';
import { useFormikContext } from 'formik';
import { ProductAmountInputFormData } from '../ProductAmountInput';
import { useHistory } from 'react-router-dom';
import { Routes } from 'routes';
import { ActivityIndicator } from 'components/activity-indicator/ActivityIndicator';
import { ReactComponent as TryBuyNowImg } from '../../../../media/images/TryBuyNowImg.svg';

export interface TryBuyNowModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const TryBuyNowModal = ({ isOpen, onClose }: TryBuyNowModalProps) => {
    const formikCtx = useFormikContext<ProductAmountInputFormData>();
    const history = useHistory();
    const [isBusy, setIsBusy] = React.useState(false);

    const beginCheckout = async () => {
        // check if form is valid
        if (!formikCtx.isValid) {
            return;
        }
        try {
            setIsBusy(true);
            formikCtx.setFieldValue('hideAddedToCartAnimation', true);
            await formikCtx.submitForm();
        } finally {
            setIsBusy(false);
        }
        history.push(Routes.ShopOrderScreen);
    };

    return (
        <Modal title="" isOpen={isOpen} onClose={onClose}>
            <div className="flex flex-col items-center">
                <TryBuyNowImg />
            </div>
            <div className="text-center p-3">
                <div className="text-3xl text-brand-dark font-semibold mb-5">Try Buy Now</div>
                <div className="mb-8 text-grey-darkest">
                    <p>
                        Introducing Buy Now, a faster and easier way to purchase your eGift Cards!
                    </p>
                    <br />
                    <p className="font-semibold">
                        To start using Buy Now for future purchases, add a payment method during
                        Checkout and complete your first order.
                    </p>
                </div>
                <div className="flex flex-col">
                    <div>
                        <Btn className="mb-7 px-16 py-3" onClick={beginCheckout} disabled={isBusy}>
                            <div className="flex">
                                {isBusy ? <ActivityIndicator width={20} /> : null}
                                <span className="ml-2">Begin Checkout</span>
                            </div>
                        </Btn>
                    </div>
                    <div>
                        <LinkBtn onClick={onClose}>Close</LinkBtn>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
